<template>
  <v-container v-show="categoryListings.length" fluid>
    <v-row no-gutters justify="center">
      <v-col md="8" class="text-h6">
        {{ $t("TOP_CATEGORY") }}
      </v-col>
    </v-row>
    <v-row no-gutters justify="center">
      <v-col md="8">
        <CardCategorySlider :categories="categories" />
      </v-col>
    </v-row>

    <div v-for="(item, i) in categoryListings" :key="i">
      <v-row justify="center" class="category-title__container">
        <v-col md="8">
          <v-row no-gutters align="center">
            <v-col class="text-h6">{{ item.category.category_name }}</v-col>
            <v-col
              cols="auto"
              class="pr-0"
              @click="logFirebaseEvent('open_template_list')"
            >
              <v-btn
                color="blue"
                class="text-body-2"
                text
                dark
                :to="{
                  name: 'categoryTemplate',
                  params: {
                    category_id: item.category.id,
                    category_name: slugify(item.category.category_name)
                  }
                }"
              >
                View all
                <v-icon small right>
                  {{ mdiArrowRight }}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col md="8">
          <v-row>
            <v-col
              v-for="(template, j) in item.category.template_list.slice(0, 4)"
              :key="j"
              cols="6"
              sm="3"
              xl="2"
              @click="logFirebaseEvent('open_template_details')"
            >
              <v-lazy v-if="i > 2">
                <thumbnail-preview :template="template"></thumbnail-preview>
              </v-lazy>
              <thumbnail-preview
                v-else
                :template="template"
              ></thumbnail-preview>
            </v-col>
            <v-col cols="12" class="d-sm-none">
              <v-btn
                color="primary"
                block
                rounded
                dark
                :to="{
                  name: 'categoryTemplate',
                  params: {
                    category_id: item.category.id,
                    category_name: item.category.category_name
                  }
                }"
              >
                View more {{ item.category.category_name }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div id="customized-cards">
      <CommonDialog title="Payment Completed">
        <strong>
          Thank you for purchasing custom card package from WedNicely.
          <br />
          One of our team member will get in touch with you shortly.
        </strong>
      </CommonDialog>
      <v-row justify="center" class="category-title__container">
        <v-col md="8" class="text-h6">{{ $t("CUSTOMIZED_CARD") }}</v-col>
      </v-row>

      <v-row justify="center">
        <v-col md="auto" class="pt-6">
          <CustomCardCard
            v-if="custome_card.custom_card"
            :custom-card="custome_card.custom_card"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import keys from "@/app-js/keys.js";
import urls from "@/app-js/urls.js";
import { mdiArrowRight } from "@mdi/js";
import CardCategorySlider from "@/components/CardCategorySlider";
import ThumbnailPreview from "@/components/ThumbnailPreview";

export default {
  components: {
    CardCategorySlider,
    ThumbnailPreview,
    CustomCardCard: () => import("@/components/CustomCardCard"),
    CommonDialog: () => import("@/components/dialogs/CommonDialog")
  },
  data() {
    return {
      mdiArrowRight,
      categories: [],
      home_list: [],
      custome_card: {}
    };
  },

  prefetch() {
    return this.fetchData();
  },

  computed: {
    categoryListings() {
      return this.home_list.filter(i => !!i.category);
    }
  },

  activated() {
    this.logFirebaseEvent("home");
    if (localStorage.getItem("transaction_id")) {
      if (localStorage.getItem("card_type")) {
        localStorage.removeItem("card_type");
      }
      this.$store.dispatch("auth/CancelPayment");
    }
  },

  methods: {
    async fetchData() {
      const params = {
        category_type: keys.INVITATION,
        parent_category_type: keys.PDF_CARD,
        language: this.$store.state.language,
        page_number: 1
      };
      const response = await this.$axios.get(urls.CARD_HOME, { params });
      this.home_list = response.data.home_list;
      for (let list of response.data.home_list) {
        if (list.custom_card) {
          this.custome_card = list;
          break;
        }
      }
      this.categories = response.data.home_list[0].category_list;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.category-title__container {
  border-bottom-style: solid;
  border-top-style: solid;
  border-width: thin;
  border-color: map-get($material-light, "dividers");
  background-color: map-get($grey, "lighten-5");
}
</style>
